import Vue from 'vue'
import App from './App.vue'

// 引入大屏组件库
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

// 👇 必须加上这两行！！！
import router from './router'  // 引入路由
Vue.use(router)                // 启用路由

new Vue({
  el: '#app',
  router, // 👇 必须加上这一行！！！
  render: h => h(App)
})